export default "__VITE_ASSET__DK57zecX__"